import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { generateId } from '@odilo/ui-components';

@Component({
  selector: 'nr-annotation-color-button',
  templateUrl: './annotation-color-button.html',
  styleUrl: './annotation-color-button.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AnnotationColorButtonComponent {
  protected readonly buttonId = generateId('color-button-');

  readonly selected = input.required<boolean>();
  readonly description = input.required<string>();
  readonly interactive = input<boolean>(true);
}
